
import { defineComponent } from "vue";
import { FilterMatchMode } from "primevue/api";
import TagCard from "@/components/furnituresView/TagCard.vue";

export default defineComponent({
  components: {
    TagCard,
  },
  data() {
    return {
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      tags: [] as any[],
      isGrid: true,
    };
  },
  methods: {
    activeGrid() {
      this.isGrid = true;
    },
    activeList() {
      this.isGrid = false;
    },
  },
  async mounted() {
    const session = JSON.parse(localStorage.getItem("tagsinfo")!);
    if (session !== null && session.tags) {
      this.tags = session.tags;
    } else {
      return {};
    }
  },
});
